import React, { useState, useEffect } from 'react'
import PersonalDetailsSection from '../../../components/ProfileForm/PersonalDetailsSection'
import ContactInformationSection from '../../../components/ProfileForm/ContactInformationSection'

const PersonalDetails = ({ data = {}, onChange, onValidityChange, dependant, setUnder16 }) => {
  const [profileData, setProfileData] = useState({
    first_name: data.firstName || '',
    last_name: data.surname || '',
    date_of_birth: {
      day: data.dob ? data.dob.split('-')[2] : '',
      month: data.dob ? data.dob.split('-')[1] : '',
      year: data.dob ? data.dob.split('-')[0] : '',
    },
    phone_number: data.phone || '',
    email: data.email || '',
  })

  const [showContactForm, setShowContactForm] = useState(false)

  const [userInfo, setUserInfo] = useState({
    gender: data.sexAssigned || '',
  })

  const validate = () => {
    const { first_name, last_name, date_of_birth, phone_number, email } = profileData
    const { gender } = userInfo
  
    // Ensure DOB fields exist
    const dobExists = date_of_birth.day && date_of_birth.month && date_of_birth.year
  
    // Only check 16-year cutoff if this is a dependant
    const validDob = dobExists && (!dependant || (() => {
      const yyyy = date_of_birth.year
      const mm = String(date_of_birth.month).padStart(2, "0")
      const dd = String(date_of_birth.day).padStart(2, "0")
      const dob = new Date(`${yyyy}-${mm}-${dd}`)
      const cutoff = new Date()
      cutoff.setFullYear(cutoff.getFullYear() - 16)
      return dob >= cutoff
    })())
  
    return (
      first_name.trim() !== '' &&
      last_name.trim() !== '' &&
      validDob &&
      !!gender &&
      (dependant || phone_number.trim() !== '') &&
      (dependant || email.trim() !== '')
    )
  }
  
  
  

  const validateBirth = () => {
    const { day, month, year } = profileData?.date_of_birth || {};
  
    if (!day || !month || !year) return false; // Missing fields
  
    const birthDate = new Date(`${year}-${month}-${day}`);
    if (isNaN(birthDate)) return false; // Invalid date
  
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
  
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    if(age < 16)
      {
        onValidityChange(true)
        setShowContactForm(false)
        setUnder16(true)
      }else{
        setUnder16(false)
        setShowContactForm(true)
        onValidityChange(false)
      }
  };
  

  useEffect(() => {
    const valid = validate()
    if (typeof onValidityChange === 'function') {
      onValidityChange(valid)
    }

    // Update parent component with current data
    const dobString =
      profileData.date_of_birth.year &&
      profileData.date_of_birth.month &&
      profileData.date_of_birth.day
        ? `${
            profileData.date_of_birth.year
          }-${profileData.date_of_birth.month.padStart(
            2,
            '0'
          )}-${profileData.date_of_birth.day.padStart(2, '0')}`
        : ''

    onChange('firstName', profileData.first_name)
    onChange('surname', profileData.last_name)
    onChange('dob', dobString)
    onChange('phone', profileData.phone_number)
    onChange('sexAssigned', userInfo.gender)
    onChange('email', profileData.email)
  }, [profileData, userInfo])

  return (
    <div className="grid grid-cols-1 gap-y-6 sm:grid-cols-6 sm:gap-x-6">
      <PersonalDetailsSection
        profileData={profileData}
        setProfileData={setProfileData}
        userInfo={userInfo}
        setUserInfo={setUserInfo}
        showTitle={false}
        dependant={dependant}
        onValidityChange={validateBirth}
        setUnder16={setUnder16}
      />
      {(!dependant || showContactForm ) && (<ContactInformationSection
        profileData={profileData}
        setProfileData={setProfileData}
        userInfo={userInfo}
        setUserInfo={setUserInfo}
        showTitle={false}
      />)}
    </div>
  )
}

export default PersonalDetails
